import { Component, Input } from '@angular/core';
import { SvgSpinnerComponent } from '@shared/components/svg-spinner/svg-spinner.component';

@Component({
  selector: 'od-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  imports: [SvgSpinnerComponent],
})
export class SpinnerComponent {
  @Input() diameter: number = 35;
}
